/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostFormResponse
 */
export interface PostFormResponse {
    /**
     * 
     * @type {string}
     * @memberof PostFormResponse
     */
    id?: string | null;
}

export function PostFormResponseFromJSON(json: any): PostFormResponse {
    return PostFormResponseFromJSONTyped(json, false);
}

export function PostFormResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFormResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function PostFormResponseToJSON(value?: PostFormResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

